import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { GlobalConstants } from 'src/app/common/constants/global.constant';
import { LogoViewModel } from '../../interface/oem-portal-interface.i';
import { Router } from '@angular/router';
import { RouterConstants } from '../../../../core/routing/constants/app-paths.constant';
import { OemService } from '../../../../../app/core/routing/services/oem/oem.service';
import { OemConstants } from '../../../../core/routing/services/oem/constants/oem.constants'
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { first } from 'rxjs/internal/operators/first';
import { Logo, CreateLogoResponse, GetAllLogoByAutoId, AssetLogoViewModel } from './interfaces/upload-logo.i';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'iposcen-upload-storelogo',
  templateUrl: './upload-storelogo.component.html',
  styleUrls: ['./upload-storelogo.component.scss']
})
export class UploadStorelogoComponent implements OnInit {
  @ViewChild('logoModal') logoModal: ElementRef;

  deleteTooltipLabel = GlobalConstants.DELETE;
  logoDeleteButton = GlobalConstants.MEDIA;
  logoDeleteName: string;
  logoToDelete: string;
  isLogoAvailable: boolean = true;
  autoId: string;
  type: string;
  typeConfiguration: string = OemConstants.IMAGE_SLASH;
  logo: AssetLogoViewModel[] = [];
  uploadLogoSortValue = GlobalConstants.UPLOAD_DATE;

  isImageSizeError: boolean;
  isImageTypeError: boolean;
  isImageUploadError: boolean;
  isimageFormat: boolean;
  uploadDateOption = GlobalConstants.UPLOAD_DATE;
  fileNameOption = GlobalConstants.FILE_NAME;

  @ViewChild('LogoDeleteModal') logoDeletePopup: ElementRef;
  private ngUnsubscribe = new Subject<boolean>();
  private modalRef: NgbModalRef;
  private modalOption: NgbModalOptions = {};
  deleteLogoData: any;
  deleteLogoLable: any;
  isDeleteDisable: boolean;
  isStoreImg: boolean;
  logoLabel = $localize`:@@upload-logo.header.sing:Logo`;

  constructor(private oemservice: OemService, private router: Router, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.type = OemConstants.LOGO;
    this.autoId = this.oemservice.getAutoId();
    this.isStoreImg = false;
    this.getAllLogoByAutoId();
  }
  open(data) {
    this.deleteLogoLable = data.fileName;
    this.deleteLogoData = data;
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.isDeleteDisable = false
    this.modalRef = this.modalService.open(this.logoDeletePopup, this.modalOption);
    this.modalRef.result.then();
  }

  close() {
    this.modalRef.close();
    this.deleteLogoData = '';

  }

  dismiss() {
    this.modalRef.dismiss();
    this.deleteLogoData = '';
  }
  deleteLogo() {
    this.oemservice.deleteVideo(this.deleteLogoData.assetID)
      .pipe()
      .subscribe(res => {
        this.close();
        this.logo = [];
        this.getAllLogoByAutoId();
      },err=>{
        this.isDeleteDisable = true;
      });
  }

  getAllLogoByAutoId() {
    this.oemservice.getAllAssetsByAutoId(this.type)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllLogoResponse => {
        const logo = [];
        const getLogoByAutoId: GetAllLogoByAutoId = getAllLogoResponse as GetAllLogoByAutoId;
        if(getLogoByAutoId.assets.length === 0){
          this.isStoreImg = true;
        }else{
          this.isStoreImg = false;
        }

        getLogoByAutoId.assets.forEach(assets => {
          const reader = new FileReader();
          const logoViewModel: AssetLogoViewModel = assets as AssetLogoViewModel;

          this.oemservice.getAssetByAutoIdAndAssetId(assets.assetID, OemConstants.SLASH_LOGO)
          .pipe(takeUntil(this.ngUnsubscribe))
          .pipe(first())
          .subscribe(imageData => {
            reader.addEventListener('load', () => {
              logoViewModel.imageData = reader.result;
              logoViewModel.fileName = assets.assetName;
              this.logo.push(logoViewModel);
              if(this.logo.length === 0){
                this.isStoreImg = false;
              }else{
                this.isStoreImg= true;
              }
              this.logo.forEach(ele => {
                ele.shortFileName = this.getShortFileName(ele.fileName);
                ele.updatedTime = new Date(ele.updatedTime);
                ele.updateTimeDisplay = new Date(ele.updatedTime).toLocaleString()
                  .replace(',', '');
              })
              this.sortBy('uploadDate');
            }, false);
            if (imageData) {
              reader.readAsDataURL(imageData);
            }
          },

            error => {
              // do something
            })
        })
      },
        error => {
          // do something
        })
        if (this.logo.length > 0) {
          this.isLogoAvailable = true;
        } else {
          this.isLogoAvailable = false;
        }
  }

  goBack() {
    this.router.navigate([RouterConstants.MODEL_SKU_INFO_LINK]);
  }

  goNext() {
    this.router.navigate([RouterConstants.MODEL_SKU_INFO_LINK]);
  }

  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  openDeleteModal() {
    this.openModal(this.logoModal)
  }

  deleteThumbnail(abc) {

  }

  sortBy(sortValue: string) {
    switch (sortValue) {
      case 'uploadDate': {
        this.uploadLogoSortValue = GlobalConstants.UPLOAD_DATE;
        this.logo.sort((logo1, logo2) => (logo2.updatedTime as any) - (logo1.updatedTime as any));
        break;
      }
      case 'fileName': {
        this.uploadLogoSortValue = GlobalConstants.FILE_NAME;
        this.logo.sort((logo1, logo2) =>
          logo1.assetName.localeCompare(logo2.assetName));
        break;
      }
      default:
        break;
    }
  }

  getShortFileName(fileName: string): string {
    let finalName: string;
    var str = fileName;
    var arr = str.split(".");
    var lastVal = arr.pop();
    var firstVal = arr.join(".");

    if (firstVal.length > 12) {
      let flname = firstVal;
      let extension = lastVal;
      flname = firstVal.substring(0, 12);
      finalName = `${flname}...${extension}`;
    } else {
      finalName = fileName;
    }
    return finalName;
  }

  processFile(imageInput) {
    const file: File = imageInput.files[0];
    const reader = new FileReader();
    const fileType = file.type.split('/')[1];
    if (file.type.split('/')[0] === GlobalConstants.FILE_TYPE_IMAGE) {
      this.isImageSizeError = file.size > GlobalConstants.UPLOAD_LOGO_IMAGE_SIZE_5MB;
      this.isImageTypeError = fileType !== GlobalConstants.CONTENT_TYPE_JPEG &&
        fileType !== GlobalConstants.CONTENT_TYPE_PNG &&
        fileType !== GlobalConstants.CONTENT_TYPE_GIF;
      this.isImageUploadError = (this.isImageSizeError || this.isImageTypeError || (this.isImageSizeError && this.isImageTypeError));
      this.isimageFormat = true;
    } else {
      this.isimageFormat = false;
      this.isImageTypeError = true;
      this.isImageUploadError = true;
    }
    if (!this.isImageUploadError) {
      reader.addEventListener('load', (event: any) => {
        const assets = {
          type: `${this.typeConfiguration}${fileType}`,
          assetName: file.name,
          assetCategory: OemConstants.LOGO
        };
        this.oemservice.uploadAssets(JSON.stringify(assets))
          .pipe(takeUntil(this.ngUnsubscribe))
          .pipe()
          .subscribe(createAsset => {
            const createLogoResponse: CreateLogoResponse = createAsset as CreateLogoResponse;
            const assetLogoViewModel: AssetLogoViewModel = createLogoResponse.assets as AssetLogoViewModel;

            //PATCH Endpoint to insert the downloadURL
            this.oemservice.updateDownloadURL(this.autoId, createAsset.assets.assetID, fileType, OemConstants.LOGO.toLowerCase())
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(res => {

              })

            this.oemservice.uploadImage(file, createAsset.assets.assetID, file.name.split('.').pop(), this.autoId, OemConstants.LOGO_ASSETS_PATH)
              .pipe(takeUntil(this.ngUnsubscribe))
              .pipe(first())
              .subscribe(() => {
                assetLogoViewModel.imageData = event.target.result;
                assetLogoViewModel.shortFileName = this.getShortFileName(file.name);;
                assetLogoViewModel.fileName = file.name;
                assetLogoViewModel.updatedTime = new Date(assetLogoViewModel.updatedTime);
                assetLogoViewModel.updateTimeDisplay = new Date(assetLogoViewModel.updatedTime).toLocaleString()
                  .replace(',', '');
                this.logo.push(assetLogoViewModel);
                this.sortBy('uploadDate');
              },

                error => {
                  // do something
                });
          },
            error => {
              // do something
            });
      });
    }
    reader.readAsDataURL(file);
  }


}
